import React from 'react';
import s from './CrossMsg.scss';

const CrossMsg = () => (
   <div className={s.container}>
       <p className={s.text}>
            Actualmente sólo ofrecemos créditos con garantía prendaria o hipotecaria.
            Si no sos titular de una propiedad te ofrecemos <a className={s.link} href="/car">utilizar tu auto como garantía.</a>
       </p>
   </div>
);

export default CrossMsg;
